import { gql } from "@apollo/client";
import moment from "moment";

export const GET_CAPAS = gql`
query allGestionCapa(
    $skip: Int
    $take: Int
    $where: GestionCapaFilterInput  
    $order: [GestionCapaSortInput!]
    $filtroFechaVencida: Int!
) {
    allGestionCapa(skip: $skip, take: $take, where: $where, order: $order, filtroFechaVencida: $filtroFechaVencida)
    {
      items{
        idGestionCapa
        puedeEditar
        fechaApertura
        fechaAccion
        fechaCierre
        idFuente
        idDelegacion
        idArea
        idResponsableAccion
        idEstado
        descripcion
        accion
        causa
        idEtapa
        idEtapaNavigation{
          descripcion
        }
        idResponsableAccionNavigation {
          nombre
          apellido
        }
        prorrogaCapa{
          fechaProrroga
          fechaAlta
          justificacion
          idUsuarioAlta
          aprobada
        }
        idEstadoNavigation {
          idEstadoReclamo
          descripcion
        }
      },
      totalCount
    }
}`;

export const adaptCapa = (capa) => {
  const ultimaProrroga = capa?.prorrogaCapa?.reduce((ultima, prorroga) => {
    const fechaProrroga = moment(prorroga?.fechaProrroga);
    return fechaProrroga.isValid() && prorroga.aprobada && (!ultima || fechaProrroga.isAfter(ultima)) ?
    fechaProrroga :
    ultima;
  }, null);

  return {
    id: capa?.idGestionCapa,
    idDelegacion: capa?.idDelegacion,
    idArea: capa?.idArea,
    fechaApertura: moment(capa?.fechaApertura).format('DD/MM/YYYY'),
    fechaCierre: moment(capa?.fechaCierre).isValid() ? moment(capa?.fechaCierre).format('DD/MM/YYYY') : '-',
    fechaAccion: ultimaProrroga ?
    ultimaProrroga :
    moment(capa?.fechaAccion).isValid() ? moment(capa?.fechaAccion) : '-',
    responsableAccion: capa?.idResponsableAccionNavigation ? `${capa?.idResponsableAccionNavigation?.nombre} ${capa?.idResponsableAccionNavigation?.apellido}` : '-',
    idFuente: capa?.idFuente,
    idEstado: capa?.idEstado,
    estado: capa?.idEstadoNavigation?.descripcion,
    idEtapa: capa?.idEtapa,
    descripcionEtapa: capa?.idEtapaNavigation?.descripcion,
    puedeEditar: capa?.puedeEditar
  };
};

const adaptCapasArray = (capasData) => {
  return structuredClone(capasData?.allGestionCapa?.items)?.
  map((capa) => adaptCapa(capa)) || [];
};

export default adaptCapasArray;